import React, { Component } from 'react';
import './Calendar.css';
import Occupied from './Occupied';
import Hvacschedule from './Hvacschedule';
import Lightingschedule from './Lightingschedule';
import Parkinglot from './Parkinglot';
import Buildingexterior from './Buildingexterior';
import {
  Route,
  NavLink,
  HashRouter
} from "react-router-dom";

//import component for window
import Modal from 'react-modal';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';

class Calendar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isPaneOpen: false,
      isPaneOpenLeft: false
    };
  }

  componentDidMount() {
    Modal.setAppElement(this.el);
  }


  render() {
   
    return <div ref={ref => this.el = ref}>
    <div className="Calendar-Container">
      <button className="button" onClick={() => this.setState({ isPaneOpen: true })}>Click here for Calendar and Hour Inputs &#187;</button>

      <SlidingPane
        className='some-custom-class'
        overlayClassName='some-custom-overlay-class'
        isOpen={this.state.isPaneOpen}
        title=''
        subtitle=''
        onRequestClose={() => {
          // triggered on "<" on left top click or on outside click
          this.setState({ isPaneOpen: false });
        }}>
        <div><Occupied options={this.props.options} onOptionsUpdate={this.props.onOptionsUpdate} /></div>
        <div className="break"></div>
        <hr />
        <div><Hvacschedule options={this.props.options} onOptionsUpdate={this.props.onOptionsUpdate} /></div>
        <div className="break"></div>
        <hr />
        <div><Lightingschedule options={this.props.options} onOptionsUpdate={this.props.onOptionsUpdate} /></div>
        <div className="break"></div>
      </SlidingPane>

</div>
    </div>;
    
  }
}

export default Calendar;


// WEBPACK FOOTER //
// ./src/components/Calendar.js